/*
 * History
 * This allows us to interact with the Browser history without being
 * dependent on a React Component Context.
 */

import { createBrowserHistory } from 'history';

const history = createBrowserHistory();
export default history;
